import { IconButton } from "@mui/material";
import cx from "classnames";
import { CloseIcon } from "@ui-icons";

interface CornerCloseBtnProps {
  onClick: () => void;
  className?: string;
  size?: "small" | "medium" | "large";
}

const CornerCloseBtn = ({
  onClick,
  className,
  size = "large",
}: CornerCloseBtnProps) => (
  <IconButton
    onClick={onClick}
    size="small"
    className={cx("absolute right-2 top-2 cursor-pointer z-10", className)}
    data-test-id="corner-close-btn"
  >
    <CloseIcon fontSize={size} />
  </IconButton>
);

export default CornerCloseBtn;
